import { transformCard } from './helperTransforms.wp';

export function transformLoadCards(rawCards = []) {
  return rawCards.map(transformCard);
}

// WP documents `pagination.total` as the page count, but guard against
// missing/zero values (errors, empty result sets).
export function getTotalPages(cardPosts) {
  const total = cardPosts?.pagination?.total;
  return Number.isInteger(total) && total > 0 ? total : 1;
}
